import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { MatSnackBar } from '@angular/material';
import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { EventTypes } from '../EventTypes';

@Component({
	selector: 'app-snack-bar',
	templateUrl: './snack-bar.component.html',
	styleUrls: ['./snack-bar.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SnackBarComponent implements OnInit, OnDestroy {

	msg: string;

	constructor( public snackBar: MatSnackBar ) {

		AppEventDispatcher.listen(EventTypes.MESSAGE.SNACK, (data) => {

			if (data.msg) {
				this.msg = data.msg;
				this.show();
			} else if (data.hide) {
				this.hide();
			}

		});

	}

	ngOnInit() {
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(EventTypes.MESSAGE.SNACK);
	}

	show() {

		this.snackBar.open(this.msg, null, {
			duration: 10000,
			verticalPosition: 'top',
			panelClass: 'snack-bar'
		});
	}

	hide() {
		this.snackBar.dismiss();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/snack-bar/snack-bar.component.ts